import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData, httpPostCall } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const depositChequeApi = async (reqObj,state) => {
  debugger
  return await httpPostCall(
    endpoint.cashManagement.chequeDashboard.depositCheque,
    reqObj,
    'post',
    true,
    {state}
  );
};

export const autoCancelChequeApi = async (applicationId) => {
  return await fetchAllPromisedData(
    endpoint.cashManagement.chequeDashboard.getChequeDetails +
      `/${applicationId}`
  );
};

// fetch a
export const getAnswers = async (question) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.chequeDashboard.chats,
    { question: question }
  );
};


export const getCashConfigurationMaster = async (reqObj) => {
 return await fetchAllPostPromisedData(
        `${endpoint?.cashManagement?.cashControlConfig?.search}?offset=${0}&pageSize=${5}`,
        reqObj,
        "post"
      );
}